import {
  FiHome,
  FiUsers,
  FiMic,
  FiCreditCard,
  FiPackage,
  FiGift,
  FiPhone,
  FiActivity,
  FiRefreshCw,
  FiTrendingUp,
  FiBell,
  FiChevronDown,
  FiChevronRight,
  FiRadio,
  FiSettings,
  FiFlag,
  FiTag,
  FiMail,
} from "react-icons/fi";
import { MdOutlineRoomPreferences, MdLeaderboard } from "react-icons/md";
import { LuIndianRupee } from "react-icons/lu";
import { getUserRole } from "./utilities/getUserRole";
import { FaHistory } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { db } from "../lib/firebase";

import { collection, query as fsQuery, where, getCountFromServer } from "firebase/firestore";
import { CiBank } from "react-icons/ci";

const navItems = [
  { label: "Dashboard", path: "/", icon: <FiHome /> },
  { label: "Users", path: "/users", icon: <FiUsers /> },
  { label: "Coin Earnings", path: "/coin-earnings", icon: <LuIndianRupee />, },
  { label: "Store Management", path: "/coin-packages", icon: <FiPackage /> },

  {
    label: "Push Notifications",
    path: "/push-notifications",
    icon: <FiBell />
  },

  // SUPER ADMIN ONLY
  {
    label: "Conversion Settings",
    path: "/conversion-settings",
    icon: <FiRefreshCw />,

  },

  // RESTRICTED ACCESS
  {
    label: "Call Configurations",
    path: "/call-config",
    icon: <FiPhone />,

  },

  { label: "Voice Approvals", path: "/voice-approval", icon: <FiMic /> },
  { label: "Withdraw Requests", path: "/withdrawals", icon: <FiCreditCard /> },
  { label: "Call History", path: "/call-transactions", icon: <FiActivity /> },
  { label: "Purchase History", path: "/purchase-history", icon: <FaHistory /> },
  { label: "Leader Board", path: "/leaderboard", icon: <MdLeaderboard /> },
  { label: "User Activity", path: "/user-activity", icon: <FiRadio /> },
  { label: "bank verification", path: "/bankVerifcation", icon: <CiBank /> },
  { label: "Analytics", path: "/analytics", icon: <FiTrendingUp /> },
  { label: "Reports", path: "/reports", icon: <FiFlag /> },
];

const Sidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [customisationsOpen, setCustomisationsOpen] = useState(false);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);
  // const [collapsed, setCollapsed] = useState(false);

  // Get user role and email from localstorage utility
  const userData = getUserRole() || {};
  const userRole = userData.role;
  const userEmail = (typeof userData.email === "string" ? userData.email : "").toLowerCase();

  // Check if notifications menu should be open based on current route
  const isNotificationsActive =
    location.pathname === "/push-notifications" ||
    location.pathname === "/in-app-notifications";

  // Check if customisations menu should be open based on current route
  const isCustomisationsActive =
    location.pathname === "/customisations";

  const isLeaderboardActive =
    location.pathname === "/leaderboard" ||
    location.pathname.startsWith("/leaderboard/");

  // Auto-open menus if on their respective pages
  useEffect(() => {
    if (isNotificationsActive) {
      setNotificationsOpen(true);
    }
    if (isCustomisationsActive) {
      setCustomisationsOpen(true);
    }
    if (isLeaderboardActive) {
      setLeaderboardOpen(true);
    }
  }, [isNotificationsActive, isCustomisationsActive, isLeaderboardActive]);

  // Pending withdrawals badge
  const [pendingWithdrawals, setPendingWithdrawals] = useState(0);
  useEffect(() => {
    let mounted = true;
    const fetchPending = async () => {
      try {
        const res = await axios.get("/api/v1/app/wallet/withdrawal-requests", {
          params: { status: "PENDING", page: 1, limit: 10 },
        });
        const payload = res?.data || {};
        const list =
          Array.isArray(payload?.data?.withdrawalRequests)
            ? payload.data.withdrawalRequests
            : Array.isArray(payload?.withdrawalRequests)
              ? payload.withdrawalRequests
              : [];
        // If API ignores status param, filter client-side
        const count = list.filter((w) => String(w?.status || "").toUpperCase() === "PENDING").length;
        if (mounted) setPendingWithdrawals(count);
      } catch (_) {
        if (mounted) setPendingWithdrawals(0);
      }
    };
    fetchPending();
    const t = setInterval(fetchPending, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const [openContactMessages, setOpenContactMessages] = useState(0);
  useEffect(() => {
    let mounted = true;
    const fetchOpenContacts = async () => {
      try {
        if (!db) return;
        const base = collection(db, "admin_support_chats");
        const openSnap = await getCountFromServer(fsQuery(base, where("status", "==", "OPEN")));
        const count = openSnap.data().count || 0;
        if (mounted) setOpenContactMessages(count);
      } catch (_) {
        if (mounted) setOpenContactMessages(0);
      }
    };
    fetchOpenContacts();
    const t = setInterval(fetchOpenContacts, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const [pendingVoiceApprovals, setPendingVoiceApprovals] = useState(0);
  const [resubmittedVoiceApprovals, setResubmittedVoiceApprovals] = useState(0);
  const [pendingBankVerification, setPendingBankVerification] = useState(0);


  useEffect(() => {
    let mounted = true;

    const fetchCounts = async () => {
      try {
        const res = await axios.get(
          "/api/v1/app/voice-verification/admin-counts"
        );

        const data = res?.data?.data || {};

        if (mounted) {
          setPendingVoiceApprovals(
            Number(data.pendingVoiceApproval || 0)
          );

          setResubmittedVoiceApprovals(
            Number(data.resubmittedVoiceApproval || 0)
          );

          setPendingBankVerification(
            Number(data.pendingBankVerification || 0)
          );
        }
      } catch (error) {
        console.error("Counts Error:", error);

        if (mounted) {
          setPendingVoiceApprovals(0);
          setResubmittedVoiceApprovals(0);
          setPendingBankVerification(0);
        }
      }
    };

    fetchCounts();

    const interval = setInterval(fetchCounts, 30000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  return (
    <aside className={`
fixed
top-0
left-0
h-screen
overflow-y-auto
overflow-x-hidden
flex
flex-col
justify-between
bg-white
text-[var(--primary-solid)]
shadow-xl
border-r-2
border-gray-200
transition-all
duration-300
ease-in-out
${collapsed ? "w-20 p-3" : "w-64 p-6"}
`}>

      <div>

        {/* Logo Section */}


        <div className="flex flex-col items-center gap-1 mb-8">
    {collapsed ? (
        <h1
            className="text-5xl font-bold text-[var(--primary-solid)]"
            style={{ fontFamily: "'Praise', cursive" }}
        >
            B
        </h1>
    ) : (
        <>
            <h2
                className="text-7xl font-bold text-[var(--primary-solid)]"
                style={{ fontFamily: "'Praise', cursive" }}
            >
                Besty
            </h2>
        </>
    )}
</div>

        <nav className="flex flex-col gap-2">
          {navItems
            .filter(item => {
              if (item.showOnlyForEmail) {
                const allowedEmails = Array.isArray(item.showOnlyForEmail)
                  ? item.showOnlyForEmail
                  : [item.showOnlyForEmail];
                return allowedEmails.some(email => email.toLowerCase() === userEmail);
              }
              return !item.role || item.role === userRole;
            })
            .map((item) => {
              // Skip rendering if it's the notifications placeholder
              if (item.label === "Notifications") return null;


              const active =
                location.pathname === item.path ||
                location.pathname.startsWith(item.path + "/");

              return (
                <Link
                  to={item.path}
                  key={item.label}
                  // className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all min-w-0 ${
                  //   active
                  //     ? "bg-[var(--primary-solid)] text-white font-semibold shadow-md"
                  //     : "hover:bg-[var(--primary-solid)]/10 hover:text-[var(--primary-solid)] text-[var(--primary-solid)]/80"
                  // }`}

                  className={`flex items-center ${collapsed ? "justify-center" : "gap-3"
                    } px-4 py-3 rounded-lg transition-all ${active
                      ? "bg-[var(--primary-solid)] text-white shadow-md"
                      : "hover:bg-[var(--primary-solid)]/10 hover:text-[var(--primary-solid)] text-[var(--primary-solid)]/80"
                    }`}

                >
                  {/* <span className="text-lg flex-shrink-0">{item.icon}</span> */}
                  <span
                    className={`text-xl ${collapsed ? "" : "flex-shrink-0"
                      }`}
                  >
                    {item.icon}
                  </span>
                  {/* <span className="truncate flex-1">{item.label}</span> */}
                  {!collapsed && (
                    <span className="truncate flex-1">
                      {item.label}
                    </span>
                  )}
                  {!collapsed &&
                    item.label === "Withdraw Requests" &&
                    pendingWithdrawals > 0 && (
                      <span className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${active ? "bg-white text-[var(--primary-solid)]" : "bg-[var(--primary-solid)] text-white"
                        }`}>
                        {pendingWithdrawals}
                      </span>
                    )}


                  {item.label === "Voice Approvals" &&
                    (pendingVoiceApprovals + resubmittedVoiceApprovals) > 0 && (
                      <span
                        className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${active
                            ? "bg-white text-[var(--primary-solid)]"
                            : "bg-[var(--primary-solid)] text-white"
                          }`}
                      >
                        {pendingVoiceApprovals + resubmittedVoiceApprovals}
                      </span>
                    )}

                  {item.label === "bank verification" &&
                    pendingBankVerification > 0 && (
                      <span
                        className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${active
                            ? "bg-white text-[var(--primary-solid)]"
                            : "bg-[var(--primary-solid)] text-white"
                          }`}
                      >
                        {pendingBankVerification}
                      </span>
                    )}

                  {item.label === "Contact Us" && openContactMessages > 0 && (
                    <span className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${active ? "bg-white text-[var(--primary-solid)]" : "bg-[var(--primary-solid)] text-white"
                      }`}>
                      {openContactMessages}
                    </span>
                  )}
                </Link>
              );
            })}

          {/* Notifications Menu with Dropdown */}



        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
